export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hrojviRmYz3HTotQNd2S1o/Captura_de_pantalla_2026-10-17_a_la(s)_9.11.00_p._m..png',
    alt: 'Interior page: Identifying Excessive Local Penetration Conditions — surface and cross-section views',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oWKRe8btGPYZd6EKb8d25r/Captura_de_pantalla_2026-10-17_a_la(s)_9.10.43_p._m..png',
    alt: 'Interior page: Recognizing Unfused-Looking Weld Metal at the Toe — toe transition comparison table',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/usk88uWYxiP15n6wUMdo8r/Captura_de_pantalla_2026-10-17_a_la(s)_9.10.17_p._m..png',
    alt: 'Interior page: Recognizing Gas-Related Cavities in Weld Metal — five porosity types',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aTyKPmDBLvyG4YZszApY9z/Captura_de_pantalla_2026-10-17_a_la(s)_9.09.37_p._m..png',
    alt: 'Interior page: Understanding What an Inspector Actually Identifies — seven-step inspection framework',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/caT4PjJeMbqtfP8udWZMTr/Captura_de_pantalla_2026-10-17_a_la(s)_9.09.12_p._m..png',
    alt: 'Interior page: Surface, Subsurface, Volumetric & Planar Discontinuities — annotated weld cross-section',
  },
]
